<template>
  <div class="center_box">
    <div class="TopTag">
      <el-tabs v-model="activeName" @tab-click="handleClick1" class="Tabs_box">
        <el-tab-pane v-for="item in CourierCompany" :key="item.id" :label="item.name" :name="item.id">
          <div>
            <div class="center_left_title">
              <span class="center_left_btn" @click="Addmenu">新增</span>
              <span class="center_Importmenu_btn" @click="Importmenu">导入</span>
            </div>
            <div class="center_left_table">
              <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection" width="55"> </el-table-column>
                <el-table-column label="不可下单地区">
                  <template slot-scope="scope">
                    <span v-for="(item, index) in scope.row.list" :key="index" style="width:50%;display:inline-block">
                      {{ item.province_name + "/" + item.city_name + "/" + item.district_name + "/" + item.street_name }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="reason" label="不可下单原因">
                  <template slot-scope="scope">
                    {{ scope.row.list[0].reason }}
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="reason" label="启用/禁用" width="150">
                  <template slot-scope="scope">
                    <el-switch :value="scope.row.list[0].status == 1 ? true : false" active-color="#13ce66" inactive-color="#e9e9e9" @change="switchClick(scope.row)"></el-switch>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="200">
                  <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small">编辑地区</el-button>
                    <el-button @click="EidthandleClick(scope.row)" type="text" size="small">编辑原因</el-button>
                    <el-button @click="DeletClick(scope.row)" type="text" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="display:flex; justify-content: space-between;align-items: center;">
              <el-select v-model="Batchoptionsvalue" @change="BatchoptionsChange" placeholder="批量操作" :disabled="visibleChange">
                <el-option v-for="item in Batchoptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="PageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 新增区域的弹框-->
    <el-dialog title="新增" :visible.sync="dialogVisible" width="70%" :before-close="handleClose" style="font-weight: 600;" center>
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="添加地区" prop="optionsOne" label-width="150px">
          <el-cascader ref="myCascader" placeholder="请选择所在街道" :props="props" clearable :options="Addoptions" v-model="form.optionsOne" style="max-height:100px;overflow: auto;"></el-cascader>
        </el-form-item>
        <el-form-item label="不可下单原因" prop="input" label-width="150px">
          <el-input v-model="form.input" clearable placeholder="请填写原因" style="width:300px"></el-input>
        </el-form-item>
      </el-form>
      <!-- <div class="Address">
        <span class="Address_left"></span>
      </div>
      <div class="AddressTwp">
        <span class="Address_left"></span>
      </div> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="affirm(0)">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 不可发货的原因 -->
    <el-dialog title="不可下单原因" :visible.sync="dialogEidt" width="30%" style="font-weight: 600;">
      <div class="AddressTwp">
        <span class="Address_left">不可下单原因</span>
        <el-input placeholder="请输入内容" style="width:300px" v-model="inputEidt" clearable> </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="NoCascaderChange">取 消</el-button>
        <el-button type="primary" @click="CascaderChange">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 不可发货的编辑地区 -->
    <el-dialog title="编辑地区" :visible.sync="dialogAddress" width="70%" style="font-weight: 600;">
      <div class="Address">
        <span class="Address_left">请选择不可发货区域</span>
        <el-cascader ref="myCascader2" :props="props" clearable v-model="optionsTwo" :options="Addoptions" @change="Twochange" style="max-height:100px;overflow: auto;"></el-cascader>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="NoEditAddress">取 消</el-button>
        <el-button type="primary" @click="EditAddress">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批量操作的弹框 -->
    <el-dialog title="提示" center :visible.sync="dialogBatchoptions" width="30%" :before-close="BatchoptionsleClose">
      <div style="width:100%;text-align:center">是否批量{{ BatchoptionsName }} ?</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="NoDialogBatchopClicl">取 消</el-button>
        <el-button type="primary" @click="YesDialogBatchopClicl">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入的弹框 -->
    <el-dialog :visible.sync="dialogImport" width="30%" :before-close="ImportClose">
      <el-upload
        class="upload-demo"
        ref="upload"
        action="https://static.xinfushenghuo.cn/api/filesup/files"
        :on-success="handleRemove"
        :file-list="fileList"
        :auto-upload="false"
        :multiple="false"
        :limit="1"
      >
        <el-button slot="trigger" size="small">选择文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="primary" @click="submitUpload">开始上传</el-button>
        <div style="margin-top:50px">注:按照正确模板格式导入文件,请先 <el-link href="https://static.xinfushenghuo.cn/publics/imgs/updatas/20220705//20220705140007597.xlsx" type="primary">下载模板</el-link></div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DelectClone">取 消</el-button>
        <el-button type="primary" @click="ImportQuery">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import {ImportAddress,BatchBtn, ExpressList,NotDdeliverAdd,NotDdeliverList,NotDdeliverAddress,,NotDdeliverDelet } from "@/api/systemange/index";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      CourierCompany: [], //快递公司数组
      activeName: 0, //当前所在的Tag
      Batchoptions: [
        {
          name: "禁用",
          id: 0
        },
        {
          name: "启用",
          id: 1
        },
        {
          name: "删除",
          id: 3
        }
      ], //批零操作的数组
      BatchoptionsName: "", //批零操作选中的值的名字
      Batchoptionsvalue: "", //批零操作选中的值
      dialogBatchoptions: false, //是否弹出批量操作选择之后的弹框
      dialogImport: false, //导入的弹框是否展示
      tableData: [], //查询数据
      dialogVisible: false, //是否展示新增弹框
      dialogEidt: false, //是否展示编辑原因弹框
      dialogAddress: false, //是否展示编辑地区弹框
      options: [], //地区所需数组
      // optionsOne:[],//新增的选中数组
      optionsTwo: [], //编辑默认选中
      // input:"",//新增不可发货原因
      inputEidt: "", //编辑不可发货原因
      props: {
        //地区所需配置
        multiple: true,
        expandTrigger: "click",
        disabled: "disabled",
        children: "childs",
        value: "code",
        label: "name"
      },
      total: 0, //数据总条数
      currentPage: 1, //数据的页数
      PageSize: 10, //数据的每页条数
      ChitID: 0, //当前选择的ID
      fileList: [], //上传导入文件的数字
      file: "", //导入时的文件信息
      multipleSelection: [], //表格选中的值
      addressOptions: [], //获取到的所有的数据源
      Addoptions: [], //绑定的options.
      FileUrl: "", //上传文件的url
      form: {
        optionsOne: [],
        input: ""
      },
      visibleChange: true, //是否可以展示批量
      rules: {
        input: [{ required: true, message: "请输入不可下单原因", trigger: "blur" }],
        optionsOne: [{ required: true, message: "请添加区域", trigger: "change" }]
      }
    };
  },
  created() {
    this.GetExpressList();
  },
  mounted() {
    this.Addoptions = JSON.parse(sessionStorage.getItem("GetCity"));
  },
  methods: {
    ...mapActions({
      BatchBtn: "FcnctionSerrings/BatchBtn",
      ExpressList: "FcnctionSerrings/ExpressList",
      NotDdeliverAdd: "FcnctionSerrings/NotDdeliverAdd",
      NotDdeliverList: "FcnctionSerrings/NotDdeliverList",
      NotDdeliverAddress: "FcnctionSerrings/NotDdeliverAddress",
      NotDdeliverCause: "FcnctionSerrings/NotDdeliverCause",
      NotDdeliverDelet: "FcnctionSerrings/NotDdeliverDelet",
      ImportAddress: "FcnctionSerrings/ImportAddress" //导入接口
    }),
    switchClick(row) {
      let data = {
        operation_id: [parseInt(row.operation_id[0])], //数组:序列号id
        status: row.list[0].status == 0 ? 1 : 0,
        merchant_id: this.$getSessionStorage("userid"),
        express_id: this.activeName
      };
      this.BatchBtn(data).then(res => {
        if (res.code == 1) {
          this.GetDdeliverList();
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    arrayToTree(arr, pid) {
      return arr.reduce((res, current) => {
        if (current["parentCode"] === pid) {
          current.children = this.arrayToTree(arr, current["code"]);
          return res.concat(current);
        }
        return res;
      }, []);
    },
    async GetExpressList() {
      let data = {
        merchantId: this.$getSessionStorage("userid")
      };
      await this.ExpressList(data).then(res => {
        if (res.code === 10000) {
          res.data.forEach(item => {
            item.id = item.id.toString();
            this.CourierCompany.push(item);
          });
          this.activeName = res.data[0].id.toString();
          this.GetDdeliverList();
        }
      });
    },
    DelectClone(){
      this.dialogImport = false
      this.fileList=[]
      this.FileUrl=''
    },
    ImportQuery() {
      let data = {
        areaId: this.activeName,
        fileUrl: this.FileUrl,
        uid: this.$getSessionStorage("userid")
      };
      this.ImportAddress(data).then(res => {
        if (res.code === 1) {
          this.dialogImport = false;
          this.$message.success("上传成功");
          this.GetDdeliverList();
          this.FileUrl=''
          this.fileList=[]
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    Twochange(val) {
      console.log("ththatis.optionsTwo :>> ", val);
    },
    submitUpload() {
      //上传事件
      this.$refs.upload.submit();
    },
    handleRemove(res) {
      //选择文件事件
      if (res.code == 1) {
        this.FileUrl = res.data.file_details[0].urls;
      }
    },
    handleClick1(tag, event) {
      //Tag选择事件
      this.GetDdeliverList(); //查询列表
    },
    BatchoptionsChange(value) {
      //批量操作的选中事件
      if (this.Batchoptions.length < 0) {
        return this.$message.error("请勾选之后再进行操作");
      }
      this.Batchoptions.forEach(item => {
        if (item.id === value) {
          this.dialogBatchoptions = true;
          this.BatchoptionsName = item.name;
        }
      });
    },
    NoDialogBatchopClicl() {
      //批量操作弹框的取消事件
      this.dialogBatchoptions = false;
      this.Batchoptionsvalue = "";
      this.BatchoptionsName = "";
    },
    handleSelectionChange(val) {
      //表格选中事件
      this.multipleSelection = val;
      if (val.length > 0) {
        this.visibleChange = false;
      } else {
        this.visibleChange = true;
      }
    },
    YesDialogBatchopClicl() {
      //批量操作弹框的确定事件
      let data = {
        operation_id: this.multipleSelection.map(item => {
          return item.operation_id;
        }), //数组:序列号id
        status: this.Batchoptionsvalue,
        merchant_id: this.$getSessionStorage("userid"),
        express_id: this.activeName
      };
      this.BatchBtn(data).then(res => {
        if (res.code == 1) {
          this.dialogBatchoptions = false;
          setTimeout(() => {
            this.Batchoptionsvalue = "";
            this.BatchoptionsName = "";
          },200);
          this.GetDdeliverList();
          this.$message.success("批量操作成功");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    Importmenu() {
      //快递公司添加按钮事件
      this.dialogImport = true;
    },
    DeletClick(row) {
      //外层删除事件
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          operation_id: row.operation_id
          // token: this.$getSessionStorage('token'),
        };
        this.NotDdeliverDelet(params, row.id).then(res => {
          if (res.code == 1) {
            this.GetDdeliverList();
            this.$message.success("成功删除数据");
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    handleClick(item) {
      //编辑地区的时候请求地区接口
      const that = this;
      that.dialogAddress = true;
      that.ChitID = item.operation_id;
      let result = [];
      item.list.forEach((index, i) => {
        result[i] = [index.province_id, index.city_id, index.district_id, index.street_id];
      });
      that.optionsTwo = result;
    },
    NoEditAddress() {
      //编辑地区关闭
      this.dialogAddress = false;
    },
    EditAddress() {
      //编辑地区事件
      let params = this.$refs.myCascader2.getCheckedNodes();
      if (params.length < 0) {
        return this.$message.error("请勾选区域");
      }
      let province_list = [];
      params.forEach(element => {
        if (element.level == 4) {
          let item = {
            city_id: element.path[1],
            city_name: element.pathLabels[1],
            province_id: element.path[0],
            province_name: element.pathLabels[1],
            district_id: element.path[2],
            district_name: element.pathLabels[2],
            street_id: element.path[3],
            street_name: element.pathLabels[3]
          };
          province_list.push(item);
        }
      });
      let data = {
        operation_id: this.ChitID,
        express_id: this.activeName,
        province_list: province_list,
        merchant_id: this.$getSessionStorage("userid")
      };
      this.NotDdeliverAddress(data).then(res => {
        if (res.code == 1) {
          this.GetDdeliverList();
          this.dialogAddress = false;
          this.$message.success("地区修改成功");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    Addmenu() {
      //新增按钮 查询城市
      this.dialogVisible = true;
      // GetProvinceCityArea().then((res) => {
      //   if (res.code == 10000) {
      //      res.data.map(eq => {
      //       eq.disabled=false
      //        const newEq={...eq}
      //        if(newEq.childs){
      //           newEq.childs =newEq.childs.map(m => {
      //           m.disabled=false
      //           const newM ={...m}
      //           if(newM.childs){
      //             newM.childs =newM.childs.map(f => {
      //               f.disabled=false
      //               const newF ={...f}
      //               return newF;
      //             });
      //           }
      //           return newM;
      //         });
      //        }
      //       return newEq;
      //      })
      //     this.options =res.data;
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // });
    },
    EidthandleClick(row) {
      //编辑原因弹框
      this.dialogEidt = true;
      this.ChitID = row.operation_id;
      this.inputEidt = row.list[0].reason;
    },
    NoCascaderChange() {
      this.dialogEidt = false;
      this.inputEidt = "";
    },
    CascaderChange(row) {
      //编辑原因确定按钮

      if (!this.inputEidt || this.inputEidt.split(" ").join("").length == 0) {
        return this.$message.error("请填写不可发货原因");
      }
      let params = {
        operation_id: this.ChitID,
        reason: this.inputEidt
        // token: this.$getSessionStorage('token'),
      };
      this.NotDdeliverCause(params).then(res => {
        if (res.code === 1) {
          this.dialogEidt = false;
          this.GetDdeliverList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    ImportClose(done) {
      //导入操作弹框关闭事件
      done();
    },
    BatchoptionsleClose(done) {
      //批量操作弹框关闭事件
      this.Batchoptionsvalue = "";
      this.BatchoptionsName = "";
      done();
    },
    handleClose(done) {
      //弹框关闭事件
      done();
    },
    GetDdeliverList() {
      //查询列表
      let params = {
        // token: this.$getSessionStorage('token'),
        page: this.currentPage,
        limit: this.PageSize, //每页条数
        express_id: this.activeName,
        merchant_id: this.$getSessionStorage("userid")
      };
      this.NotDdeliverList(params).then(res => {
        if (res.code === 1) {
          this.tableData = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    affirm(num) {
      //同意事件
      let params = this.$refs.myCascader.getCheckedNodes();
      if (params.length < 0) {
        return this.$message.error("请勾选区域");
      }
      if (!this.form.input || this.form.input.split(" ").join("").length == 0) {
        return this.$message.error("请填写不可发货原因");
      }
      let province_list = [];
      params.forEach(element => {
        if (element.level == 4) {
          let item = {
            city_id: element.path[1],
            city_name: element.pathLabels[1],
            province_id: element.path[0],
            province_name: element.pathLabels[0],
            district_id: element.path[2],
            district_name: element.pathLabels[2],
            street_id: element.path[3],
            street_name: element.pathLabels[3]
          };
          province_list.push(item);
        }
      });
      let data = {
        // token:this.$getSessionStorage('token'),
        reason: this.form.input,
        merchant_id: this.$getSessionStorage("userid"),
        province_list: province_list,
        express_id: this.activeName
      };
      if (num == 1) {
        this.NotDdeliverAdd(data).then(res => {
          if (res.code === 1) {
            const optionsOne = [];
            res.data.forEach(item => {
              optionsOne.push(item.street_id);
            });
            // this.options.forEach(item1 => {
            //   if(item1.childs){
            //     item1.childs.forEach(item2 =>{
            //       if(item2.childs){
            //         item2.childs.forEach(item3=>{
            //           optionsOne.forEach(item4 =>{
            //             if(item4==item3.code){
            //               item3.disabled=true
            //             }
            //           })
            //         })
            //       }
            //     })
            //   }
            // })
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.NotDdeliverAdd(data).then(res => {
          if (res.code === 1) {
            this.dialogVisible = false;
            this.GetDdeliverList();
            this.form.input = "";
            this.form.optionsOne = [];
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    cancel() {
      //取消事件
      this.dialogVisible = false;
      this.form.input = "";
      this.form.optionsOne = [];
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.GetDdeliverList();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetDdeliverList();
    }
  }
};
</script>

<style scoped lang="scss">
.center_box {
  width: 100%;
  box-sizing: border-box;
  min-height: 800px;
  padding: 14px 25px;
  background-color: #e9e9e9;
  .TopTag {
    position: relative;
    .AddImportmenu {
      position: absolute;
      top: 20px;
      right: 150px;
    }
    .Tabs_box {
      padding: 20px 40px;
      background-color: #fff;
    }
  }

  .center_left_title {
    height: 30px;
    background-color: #fff;
    padding: 20px 0;
    margin-bottom: 10px;
    .center_Importmenu_btn {
      width: 93px;
      height: 32px;
      line-height: 32px;
      display: inline-block;
      text-align: center;
      font-size: 14px;
      color: #fff;
      background: #0084ff;
      border-radius: 2px;
      margin-bottom: 24px;
      margin-left: 20px;
    }
    .center_left_btn {
      width: 93px;
      height: 32px;
      line-height: 32px;
      display: inline-block;
      text-align: center;
      font-size: 14px;
      color: #fff;
      background: #0084ff;
      border-radius: 2px;
      margin-bottom: 24px;
    }
  }
  .center_left_table {
    background-color: #fff;
    padding-bottom: 20px;
    padding-top: 20px;
  }
}
.Address {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 200px;
  .Address_left {
    width: 150px;
    margin-right: 30px;
    text-align: center;
  }
}
.AddressTwp {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 20px;
  .Address_left {
    width: 150px;
    text-align: center;
    margin-right: 30px;
  }
}
::v-deep .el-cascader__tags {
  top: 5px;
  transform: translateY(-0);
}
</style>
